import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MainPage } from '../pages/main-page';

const mainPageSearchSchema = z.object({
  bookingType: z
    .union([z.literal('your-tour'), z.literal('accommodation'), z.literal('excursion')])
    .optional(),
});

export const Route = createFileRoute('/')({
  validateSearch: mainPageSearchSchema,
  component: MainPage,
});
